import debug from 'debug'
import { createBrowserRouter } from 'react-router'
import { isMigratedRouteModulesEnabled } from 'src/experiments/experiments/2601/migratedRouteModules'
import { detectRouterNavigations } from 'src/utils/router/routerCycleDetection'
import { routes as legacyRoutes } from './legacy-routes'
import { routes as migratedRoutes } from './routes'

const log = debug('pixai:router')

export const routes = isMigratedRouteModulesEnabled
  ? migratedRoutes
  : legacyRoutes

if (log.enabled) {
  log(
    `Activated: data router, ${isMigratedRouteModulesEnabled ? 'migrated routes' : 'legacy routes'}`,
  )
  log('routes:', routes)
  log(
    'app routes:',
    routes
      .find(r => r.handle?.name === 'root')
      ?.children?.find(r => r.handle?.name === 'app-layout'),
  )
}

export const router = createBrowserRouter(routes)

// Detects redirect loops by counting visits to the same path.
// Any rule matched triggers hard-redirect to /error.
detectRouterNavigations(router, {
  rules: [
    { duration: 1_000, maxCount: 20 }, // > 20 visits to same path within 1s
    // { duration: 5_000, maxCount: 20 },
  ],
})
